import { render, staticRenderFns } from "./ProBadge.vue?vue&type=template&id=79acc426"
import script from "./ProBadge.vue?vue&type=script&lang=js"
export * from "./ProBadge.vue?vue&type=script&lang=js"
import style0 from "./ProBadge.vue?vue&type=style&index=0&id=79acc426&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports